import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { expandCollapseAnimation } from '../../../../../assets/animations';
import { IProductos, IPromosEcommerce } from '../../../../private/shared/models/productos';
import { SwipeActionsComponent, SwipeActionType } from '../swipe-actions/swipe-actions.component';

@Component({
  selector: 'getm-cart-promo-item',
  templateUrl: './cart-promo-item.component.html',
  styleUrls: ['./cart-promo-item.component.scss'],
  animations: [expandCollapseAnimation],
})
export class CartPromoItemComponent {

  @ViewChild('swipeActions') swipeActions!: SwipeActionsComponent;

  @Input() promo: IPromosEcommerce = {} as IPromosEcommerce;
  @Input() set productos(value: IProductos[]) {
    this.productosTotales = value;
    this.discountedProducts = value.filter(p => (p.precio ?? 0) !== (p.precio_original ?? 0));
    this.regularProducts = value.filter(p => (p.precio ?? 0) === (p.precio_original ?? 0));
  }
  @Input() actions: SwipeActionType[] = ['edit', 'delete'];
  @Input() ID_Programa: number = 0;
  @Input() isOrderActive: boolean = false;

  @Output() quantityChange = new EventEmitter<{ ClavePromo: string; quantity: number }>();
  @Output() editItem = new EventEmitter<IPromosEcommerce>();
  @Output() removeItem = new EventEmitter<IPromosEcommerce>();

  public isExpanded = false;
  public productosTotales: IProductos[] = [];
  public discountedProducts: IProductos[] = [];
  public regularProducts: IProductos[] = [];

  public toggleDetail(): void {
    this.isExpanded = !this.isExpanded;
  }

  public openOptions(): Promise<void> {
    return this.swipeActions.openOptions();
  }

  public onQuantityChange(quantity: number): void {
    this.quantityChange.emit({ ClavePromo: this.promo.ClavePromo, quantity });
  }

  public onEditItem(): void {
    this.editItem.emit(this.promo);
  }

  public onDeleteItem(): void {
    this.removeItem.emit(this.promo);
  }
}
